import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { EnquiryForm } from './EnquiryForm';
import { BOOKING_VARIANTS } from './data';

export const BookingModal = ({ variant, onClose }) => {
  const v = BOOKING_VARIANTS[variant] || BOOKING_VARIANTS.viewing;
  return (
    <Dialog open={Boolean(variant)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto bg-[#1a1e1a] border border-white/15 p-0" data-testid="booking-modal">
        <div className="p-7 md:p-10">
          <p className="text-[#d6cdb4] text-xs tracking-[0.2em] uppercase mb-4" data-testid="booking-eyebrow">{v.eyebrow}</p>
          <DialogTitle className="text-white text-2xl md:text-3xl font-light mb-3">{v.title}</DialogTitle>
          <p className="text-white/80 text-sm leading-relaxed mb-8">{v.copy}</p>
          <EnquiryForm key={variant} prefix="booking" source={v.source} interest={v.interest} submitLabel={v.submit} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
